import {
  ACTIVATE_CLIENT_SHORT_INFO_SAGA,
  CHANGE_CLIENT_SHORT_INFO_FAILED,
  CHANGE_CLIENT_SHORT_INFO_REQUESTED,
  CHANGE_CLIENT_SHORT_INFO_SUCCESS,
  GET_CLIENT_DETAILS_FAILED,
  GET_CLIENT_DETAILS_REQUEST,
  GET_CLIENT_DETAILS_SUCCESS,
  GET_SHORT_CASHBOXES_LIST_FAILED,
  GET_SHORT_CASHBOXES_LIST_SUCCESS,
  GET_SHORT_CASHBOXES_REQUESTED,
  GET_SHORT_INFO_FAILED,
  GET_SHORT_INFO_REQUESTED,
  GET_SHORT_INFO_SUCCESS,
  SHORT_INFO_RESET,
  ACCESS_TO_CONTRACT_CREATION_ERROR
} from './actionTypes';

export const getShortInfo = clientId => ({
  type: GET_SHORT_INFO_REQUESTED,
  clientId
})

export const getShortInfoSuccess = payload => ({
  type: GET_SHORT_INFO_SUCCESS,
  payload
})

export const getShortInfoFailed = payload => ({
  type: GET_SHORT_INFO_FAILED,
  payload
})

export const getShortCashBoxList = clientId => ({
  type: GET_SHORT_CASHBOXES_REQUESTED,
  clientId
})

export const getShortCashBoxListSuccess = payload => ({
  type: GET_SHORT_CASHBOXES_LIST_SUCCESS,
  payload
})

export const getShortCashBoxListFailed = payload => ({
  type: GET_SHORT_CASHBOXES_LIST_FAILED,
  payload
})

export const clientShortInfoSaga = (clientId) => ({
  type: ACTIVATE_CLIENT_SHORT_INFO_SAGA,
  clientId
})

export const changeClientShortInfo = (clientId, data) => ({
  type: CHANGE_CLIENT_SHORT_INFO_REQUESTED,
  clientId,
  data
})

export const changeClientShortInfoSuccess = (payload) => ({
  type: CHANGE_CLIENT_SHORT_INFO_SUCCESS,
  payload
})

export const changeClientShortInfoFailed = (payload) => ({
  type: CHANGE_CLIENT_SHORT_INFO_FAILED,
  payload
})

export const getClientDetails = clientId => ({
  type: GET_CLIENT_DETAILS_REQUEST,
  clientId
})

export const getClientDetailsSuccess = payload => ({
  type: GET_CLIENT_DETAILS_SUCCESS,
  payload
})

export const getClientDetailsFailed = payload => ({
  type: GET_CLIENT_DETAILS_FAILED,
  payload
})

export const resetShortInfo = () => ({ type: SHORT_INFO_RESET })


export const errorAccessToContractCreation = payload => ({
  type: ACCESS_TO_CONTRACT_CREATION_ERROR,
  payload
})
